import React from 'react';
import { Alert, Form, Modal } from "antd";
import { Select } from "../../../shared/OptionWidthControl";
import ReasonFields from '../../../payments-v2/views/shared/ReasonFields';
import LifecycleBlockers from '../../../payments-v2/views/shared/LifecycleBlockers';
import { backTargets, stageLabel, useLifecycleDialog } from '../../viewmodels/modals-misc/useLifecycleDialog';
export const movableBackStatuses = backTargets;
export const isMoveBackAvailable = status => status !== 'confirmed_waiting_payment' && backTargets(status).length > 0;
export function MoveStatusModal(props) {
  const [form] = Form.useForm();
  const vm = useLifecycleDialog({ ...props, kind: 'back' });
  return <Modal open={props.open} title={`Move Task Back — #${props.queryId || ''}`} onCancel={props.onClose} onOk={() => form.submit()} confirmLoading={vm.saving} okButtonProps={{ disabled: !vm.authority.allowed }} okText="Move Back" destroyOnHidden>
    <LifecycleBlockers error={vm.error} queryPk={props.queryPk} queryId={props.queryId} capabilities={vm.capabilities} onRevise={props.onRevise} />
    {!vm.authority.allowed && <Alert type="warning" message={vm.authority.reason || vm.authority.reason_code || 'Not available'} />}
    <Form form={form} layout="vertical" onFinish={vm.submit}>
      <Form.Item name="to_status" label="Move back to" rules={[{ required: true }]}><Select options={backTargets(props.currentStatus).map(value => ({ value, label: stageLabel(value) }))} /></Form.Item>
      <ReasonFields action="query_move" />
    </Form>
  </Modal>;
}
